import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Flame } from 'lucide-react';

const START = new Date('2026-09-21T00:00:00');
const END = new Date('2026-10-01T23:59:59');

const getTimeLeft = () => {
  const diff = START - new Date();
  if (diff <= 0) return null;
  return {
    giorni: Math.floor(diff / 86400000),
    ore: Math.floor((diff / 3600000) % 24),
    minuti: Math.floor((diff / 60000) % 60),
    secondi: Math.floor((diff / 1000) % 60),
  };
};

export default function TrialCountdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  if (new Date() > END) return null;

  return (
    <section data-testid="trial-countdown-section" className="relative overflow-hidden bg-gradient-to-r from-[#FF7043] via-[#FF5722] to-[#F4511E] py-8 md:py-10">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute -top-16 left-1/4 w-56 h-56 rounded-full bg-[#FFCA28]" />
        <div className="absolute -bottom-20 right-10 w-64 h-64 rounded-full bg-white" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex flex-col lg:flex-row items-center justify-between gap-6">
        <div className="text-center lg:text-left">
          <div className="inline-flex items-center gap-1.5 text-[#FFE0B2] font-bold text-xs uppercase tracking-[0.2em] mb-1">
            <Flame size={14} className="text-[#FFCA28]" /> Non perdere l'occasione
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-black tracking-tight text-white">
            {timeLeft ? 'Le Prove Gratuite stanno arrivando!' : 'Le Prove Gratuite sono in corso!'}
          </h2>
          <p className="text-white/85 text-sm md:text-base mt-1">
            Dal 21 settembre al 1 ottobre — la prima lezione è gratuita!
          </p>
        </div>

        {timeLeft && (
          <div className="flex items-center gap-2 md:gap-3" data-testid="trial-countdown-timer">
            {Object.entries(timeLeft).map(([label, value]) => (
              <div key={label} className="flex flex-col items-center bg-white/15 backdrop-blur-md border border-white/25 rounded-2xl px-3 py-2 md:px-4 md:py-3 min-w-[64px] md:min-w-[76px]">
                <span className="font-heading text-2xl md:text-3xl font-black text-white tabular-nums">
                  {String(value).padStart(2, '0')}
                </span>
                <span className="text-[10px] md:text-xs font-bold uppercase tracking-wider text-[#FFE0B2]">
                  {label}
                </span>
              </div>
            ))}
          </div>
        )}

        <Link
          to="/lezioni-prova"
          data-testid="countdown-cta-btn"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-[#FF5722] font-heading font-black text-base rounded-full shadow-lg hover:scale-105 transition-transform"
        >
          {timeLeft ? 'Scopri gli Orari' : 'Prenota Subito'} <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
}
